export default "__VITE_ASSET__B6QSl$rB__"